
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 64 64","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M48.6 23.3H38.3v14.1h-22l-1.5-2.1 19-4.6c1.4-.4 2.4-1.7 2.4-3.1 0-1.6-1.2-3-2.8-3.2L21.7 23v-7.2H9.9V22c0 1.4 1.1 2.5 2.5 2.5H15c0 .9.6 1.7 1.5 1.8l13 1.4-18 4.3H9.2v9.9h4.1c0 3.4 2.8 6.2 6.2 6.2s6.2-2.8 6.2-6.2h12.4c0 3.4 2.8 6.2 6.2 6.2s6.2-2.8 6.2-6.2h4.1V31.6l-6-8.3zM19.6 45c-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1s3.1 1.4 3.1 3.1c0 1.7-1.4 3.1-3.1 3.1zm24.8 0c-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1s3.1 1.4 3.1 3.1c0 1.7-1.3 3.1-3.1 3.1zm-2-13.4v-5.2h5.2l4.1 5.2h-9.3z"}})])
          )
        }
      }
    